/**
 * @typedef {import("react").HTMLAttributes<SVGElement>} IProps
 * */
/**
 * @returns {JSX.Element} Круглая иконка Telegram
 * @param {IProps} props
 * */
export default function TelegramIcon() {
  return (
    <svg width="22" height="23" viewBox="0 0 22 23" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.497559" width="22" height="22" rx="11" fill="url(#paint0_linear_7745_568242)" />
      <path
        d="M16.7401 6.71981L14.5535 15.7324C14.4506 16.1568 13.9746 16.3755 13.5844 16.1739L10.8188 14.7462L9.51108 16.8857C9.15526 17.4688 8.25486 17.2159 8.25486 16.5341V14.1501C8.25486 13.9658 8.332 13.79 8.46494 13.6614L13.8546 8.51624C13.8503 8.45192 13.7817 8.39622 13.7131 8.44331L7.28172 12.9196L5.12079 11.8048C4.6149 11.5432 4.63634 10.81 5.15936 10.5828L15.8142 5.93947C16.3244 5.71648 16.8733 6.17529 16.7403 6.71977L16.7401 6.71981Z"
        fill="#F8FCFE"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7745_568242"
          x1="11"
          y1="0.497559"
          x2="11"
          y2="22.4976"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37AEE2" />
          <stop offset="1" stopColor="#1E96C8" />
        </linearGradient>
      </defs>
    </svg>
  );
}
